import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class RedirectGuard implements CanActivate {
	private constantsCache: Record<string, Record<string, string>> = {};

	constructor(
		private router: Router,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		const currentPath = state.url;

		if (isPlatformBrowser(this.platformId) && currentPath.includes('/shop/find-a-retailer')) {
			const fromUrl = this.router.url;
			if (!fromUrl.includes('/my-cart')) {
				const uuid = this.generateUUID();
				window.open(`${environment.pickerLauncherUrl}?context=${uuid}&mode=PICKER`, '_blank', 'noopener,noreferrer');
				return false;
			}
		}

		if (currentPath.includes('all-things-flooring-blog/recent-blogs')) {
			this.router.navigateByUrl(currentPath.replace('all-things-flooring-blog/recent-blogs', 'blog'));
			return false;
		}

		if (currentPath.includes('all-things-flooring-blog')) {
			this.router.navigateByUrl(currentPath.replace('all-things-flooring-blog', 'blog'));
			return false;
		}

		const URLRedirectConstants = await this.loadRedirectUrlData();
		const decodedPath = currentPath.includes('%20') ? currentPath.replace(/%20/g, ' ') : currentPath;
		const pathWithoutQuery = decodedPath.includes('?') ? decodedPath.split('?')[0] : decodedPath;
		const redirectPath = URLRedirectConstants[pathWithoutQuery] ?? URLRedirectConstants[currentPath];

		if (redirectPath) {
			return this.router.parseUrl(decodeURIComponent(redirectPath));
		}

		return true;
	}

	private async loadRedirectUrlData(): Promise<Record<string, string>> {
		if (!this.constantsCache['URLRedirectConstants']) {
			const module = await import('@app/shared/constants/URL-redirects.constants');
			this.constantsCache['URLRedirectConstants'] = module.URLRedirectConstants;
		}
		return this.constantsCache['URLRedirectConstants'];
	}

	private generateUUID(): string {
		if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
			return crypto.randomUUID();
		}
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			const r = (Math.random() * 16) | 0;
			const v = c === 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}
}
